import { render, staticRenderFns } from "./QuestionInfo.vue?vue&type=template&id=a5781ea4&scoped=true"
import script from "./QuestionInfo.vue?vue&type=script&lang=js"
export * from "./QuestionInfo.vue?vue&type=script&lang=js"
import style0 from "./QuestionInfo.vue?vue&type=style&index=0&id=a5781ea4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5781ea4",
  null
  
)

export default component.exports